export default function AddedStudentsList({ addedStudents }) {
  return (
    addedStudents.length > 0 && (
      <table className="table table-light">
        <thead>
          <tr>
            <th scope="col" colSpan="5">
              Criança(s) adicionada(s) neste acidente:
            </th>
          </tr>
        </thead>
        <tbody>
          {addedStudents.map((student, index) => (
            <tr key={index}>
              <td>{student.name}</td>
              <td>{student.gender}</td>
              <td>{student.age}</td>
              <td title={student.followUpDescription}>
                <div
                  className="d-inline-block text-truncate"
                  style={{ maxWidth: "100px" }}
                >
                  {student.followUpDescription}
                </div>
              </td>
              <td title={student.procedureDescription}>
                <div
                  className="d-inline-block text-truncate"
                  style={{ maxWidth: "100px" }}
                >
                  {student.procedureDescription}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  );
}
